const ADD_BATCH_ASSIGNMENTS = `mutation AddAssignments($entityIdList: [ID!]!, $entityType: Entity!, $assignmentType: String, $manifest: [AssignmentManifestInput]) {
  batchAddAssignment(input: {entityIdList: $entityIdList, entityType: $entityType, assignmentType: $assignmentType, manifest: $manifest}) {
    assignmentId
    assignmentType
    assignor
    createdAt
    status
  }
}`;

export default ADD_BATCH_ASSIGNMENTS;
